import { parametersServices } from "../../../services";

export async function Platforms() {
	const platforms = await parametersServices.getPlatforms();

	const columns = [
		{
			key: "id",
			name: "#",
			sort: 0,
			type: "id",
		},
		{
			key: "value",
			name: "static-parameters.title",
			sort: 1,
			type: "title",
		},
		{
			key: "key",
			name: "static-parameters.key",
			sort: 2,
			type: "title",
		},
	];
	const rows = [];

	await platforms.payload?.map((platform, key) => {
		rows.push({
			id: key + 1,
			value: platform.value,
			key: platform.key,
		});
	});
	const tableData = {
		columns: columns,
		rows: rows,
	};
	return tableData;
}
